import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { HttpRequestService } from 'src/app/common-services/http-request.service';
import { TranslationService } from 'src/app/common-services/translation.service';

interface Kyc_score{
  basepoint:number
  pan:number
  gst:number
  pf:number
  esic:number
  itr_current_year:number
  itr_secondlast_year:number
  itr_thirdlast_year:number
  reference_contact_details1:number
  reference_contact_details2:number
  work_order1:number
  work_order2:number
  work_order_cert1:number
  work_order_cert2:number
  lin:number
  cin:number
  tax_tan:number
  date_of_incorporation:number
  mobile_no:number
  email:number
  msme:number
  mgmt_quota:number
  created_by_date:Date
  created_by_id:number
  created_by_name:string
  modified_by_id:number
  modified_by_name:string
  modified_by_date:Date
  
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})


export class KYCListComponent implements OnInit {
  constructor(private http:HttpRequestService, private lang: TranslationService,
    private translate: TranslateService,private toaster: ToastrService) { 
               
    let userLang = this.lang.selectLang.value;
    translate.addLangs(['en-US', 'hi-IN', 'mr-IN', 'bn-IN']);
    translate.setDefaultLang(localStorage.getItem('lang'));
    translate.use(localStorage.getItem('lang'));
    // this.browserLang = translate.getDefaultLang();        
    // this.lang.selectLang.next(this.browserLang);
  }

  totalRecords:number
  dataSource=[
    {id:1,name:'kyc_1',number:20},
    {id:1,name:'kyc_2',number:30},
    {id:1,name:'kyc_3',number:57},
    {id:1,name:'kyc_4',number:78},
    {id:1,name:'kyc_6',number:87},
    {id:1,name:'kyc_7',number:78},
  
  ]

  logs=[];

  displayedColumns: string[] = ['Perticular', 'Score',  'action'];
  displayedLogs: string[] = ['created', 'modified'];

  kyc_score:Kyc_score

  userInfo;
  TotalScore:number=999;
  Dbcount:number=0;
  buttonState:boolean=false;


  ngOnInit(): void {

this.userInfo= this.http.tokenInfo();

console.log("user infp", this.userInfo);


    // console.log("kyc score",this.kyc_score);
    this.getKycAutomationScore();


    
  }


  // limitation

  onlyChars(event)
  {
    
    let lenght=event.target.value.length;
   
    if(lenght<=2){
     
      return true
    }else{
     
      return false
    }
  
    
  }


  // get kyc data
  getKycAutomationScore()
  {

      this.http.kycAutomation('get','kyc_rating_score',null).subscribe(res=>{
      console.log("res-->",res);
      
      this.kyc_score=res['data'];

      console.log("kyc score", this.kyc_score);

      this.dataSource=[
        {id:1,name:'Base Point',number:this.kyc_score.basepoint},
        {id:2,name:'CIN',number:this.kyc_score.cin},
        {id:3,name:'Date of Incorporation',number:this.kyc_score.date_of_incorporation},
        {id:4,name:'Email',number:this.kyc_score.email},
        {id:5,name:'GST',number:this.kyc_score.gst},
        {id:6,name:'ITR current year',number:this.kyc_score.itr_current_year},
        {id:7,name:'ITR second last year',number:this.kyc_score.itr_secondlast_year},
        {id:8,name:'ITR third last year',number:this.kyc_score.itr_thirdlast_year},
        {id:9,name:'LIN',number:this.kyc_score.lin},
        {id:10,name:'MGMT quota',number:this.kyc_score.mgmt_quota},
        {id:11,name:'Mobile No',number:this.kyc_score.mobile_no},
        {id:12,name:'MSME',number:this.kyc_score.msme},
        {id:13,name:'PAN',number:this.kyc_score.pan},
        {id:14,name:'PF',number:this.kyc_score.pf},
        {id:15,name:'Reference contact details 1',number:this.kyc_score.reference_contact_details1},
        {id:16,name:'Reference contact details 2',number:this.kyc_score.reference_contact_details2},
        {id:17,name:'TAX TAN',number:this.kyc_score.tax_tan},
        {id:18,name:'Work order 1',number:this.kyc_score.work_order1},
        {id:19,name:'Work order 2',number:this.kyc_score.work_order2},
        {id:20,name:'Work order certificate 1',number:this.kyc_score.work_order_cert1},
        {id:21,name:'Work order certificate 2',number:this.kyc_score.work_order_cert2},
        {id:22,name:'esic',number:this.kyc_score.esic},
        
        
      ]

      this.logs=[

        {id:1,created_date:this.kyc_score.created_by_date,created_name:this.kyc_score.created_by_name, modified_by_date:this.kyc_score.modified_by_date , modified_by_name:this.kyc_score.modified_by_name ,number:this.kyc_score.basepoint},
      
      ]

      

      this.dataSource.map(item=>{

        let num:number=item['number']
        // console.log("num--",num);
        
        this.Dbcount= this.Dbcount+num;
      })

      console.log("count", this.Dbcount);
      
      console.log("data socur", this.dataSource);
      
      this.totalRecords=this.dataSource.length

      
      
    })
  }


  // kyc update data on blur 

  kycScoreUpdate(data, index){

    console.log(" data",data);
    console.log("index",index);

    this.Dbcount=0;

    this.valueInser(index,data)
 
  }


  // value insert into object

  valueInser(index,data)
  {

    this.Dbcount=0;
    if(index==1)
    {
      this.kyc_score.basepoint=data
    }
    if(index==2)
    {
      this.kyc_score.cin=data
    }
    if(index==3)
    {
      this.kyc_score.date_of_incorporation=data
    }
    if(index==4)
    {
      this.kyc_score.email=data
    }
    if(index==5)
    {
      this.kyc_score.gst=data
    }
    if(index==6)
    {
      this.kyc_score.itr_current_year=data
    }
    if(index==7)
    {
      this.kyc_score.itr_secondlast_year=data
    }
    if(index==8)
    {
      this.kyc_score.itr_thirdlast_year=data
    }
    if(index==9)
    {
      this.kyc_score.lin=data
    }
    if(index==10)
    {
      this.kyc_score.mgmt_quota=data
    }
    if(index==11)
    {
      this.kyc_score.mobile_no=data
    }
    if(index==12)
    {
      this.kyc_score.msme=data
    }
    if(index==13)
    {
      this.kyc_score.pan=data
    }
    if(index==14)
    {
      this.kyc_score.pf=data
    }
    if(index==15)
    {
      this.kyc_score.reference_contact_details1=data
    }
    if(index==16)
    {
      this.kyc_score.reference_contact_details2=data
    }
    if(index==17)
    {
      this.kyc_score.tax_tan=data
    }
    if(index==18)
    {
      this.kyc_score.work_order1=data
    }
    if(index==19)
    {
      this.kyc_score.work_order2=data
    }
    if(index==20)
    {
      this.kyc_score.work_order_cert1=data
    }
    if(index==21)
    {
      this.kyc_score.work_order_cert2=data
    }
    if(index==22)
    {
      this.kyc_score.esic=data
    }


    console.log("final updated score", this.kyc_score);

    this.Dbcount=Number(this.kyc_score.cin)+
    Number(this.kyc_score.date_of_incorporation)+
    Number(this.kyc_score.email)+
    Number(this.kyc_score.esic)+
    Number(this.kyc_score.gst)+
    Number(this.kyc_score.itr_current_year)+
    Number(this.kyc_score.itr_secondlast_year)+
    Number(this.kyc_score.itr_thirdlast_year)+
    Number(this.kyc_score.lin)+
    Number(this.kyc_score.mgmt_quota)+
    Number(this.kyc_score.mobile_no)+
    Number(this.kyc_score.basepoint)+
    Number(this.kyc_score.cin)+
    Number(this.kyc_score.work_order_cert2)+
    Number(this.kyc_score.tax_tan)+
    Number(this.kyc_score.reference_contact_details2)+
    Number(this.kyc_score.reference_contact_details1)+
    Number(this.kyc_score.pf)+
    Number(this.kyc_score.pan)+
    Number(this.kyc_score.msme);


console.log("final count", this.Dbcount);



if(this.TotalScore>=this.Dbcount)
{
  console.log("you are under 999", this.Dbcount);
  this.buttonState=false;
  
}else
{
  this.buttonState=true;
  console.log("you are out of 999", this.Dbcount);

   

  // this.toaster.error('You are exceeding the high limit :999');
  
}




  }


  // update all lc score

  updateAllLCScore()
  {

    console.log("update function call");
    
    this.http.kycAutomation('get','all_lc_kyc_update',null).subscribe(res=>{
      console.log("update all lc", res);
      
    })
  }
  
  // update score
  UpdateKycScore()
  {
    this.kyc_score['modified_by_id']=this.userInfo.user_id;
    this.kyc_score['modified_by_date']= new Date();
    this.kyc_score['modified_by_name']=this.userInfo.Name;

    
    
    console.log("kyc score", this.kyc_score);

    if(this.buttonState)
    {
      this.toaster.error('You have exceeded the limit of Total KYC score i.e. 999');
      
    }else{

      this.http.kycAutomation('put','kyc_rating_update/1', this.kyc_score).subscribe(res=>{
        console.log("updated succesfully");
  
        this.toaster.success('Recoed Updated Succesfully');
  
        this.updateAllLCScore();
        // location.reload();
        
        
      })
    }
 
    
  }
  

}
